console.log('✅ listing-page-component.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import { isNodeEnvironment} from '../../js/utils-fetch-data-json.js';


import { fetchAllBlogCategories } from '../../services/data-services/blog-data-service.js';
import { updateBlogTopNavSelectedHighlightToSelectedListeners } from './blog-top-nav.js';

export async function buildComponentBlogCategories() {
  console.log(
    `🔄 Building Component: buildComponentBlogCategories - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    let htmlToRender = '';

    if (isNodeEnvironment()) {
      htmlToRender = await buildActualContent();
    } else {
      htmlToRender = await buildPageSkeleton();
    }

    const html = `
      


    ${htmlToRender}

      


        `;

    console.log('✅ buildComponentBlogCategories built successfully.');

    // // Register event listeners
    // // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () => initbuildComponentBlogCategories());

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentBlogCategories:', err);
    return '<div>Error loading buildComponentBlogCategories </div>';
  }
}

export async function buildPageSkeleton() {
  // Top two “featured” cards
  const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

  const topCardsSkeletonHtml2 = `
    <div class="grid-blog-category-home-featured-top-card my-fake-image-height-400">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
    `;

  let middleCardsSkeleton = '';
  for (let i = 0; i < 12; i++) {
    middleCardsSkeleton += `
      <div class="grid-blog-home-all-category-section-card my-fake-image-height-400">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        
    `;
  }

  // Sidebar section: repeat 5 times
  let sideBarCardsSkeleton = '  <br>  <br>';
  for (let i = 0; i < 5; i++) {
    sideBarCardsSkeleton += `
                <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        <br />

    `;
  }

  // Middle section: repeat 6 times
  let bottomCardsSkeleton = '';
  for (let i = 0; i < 6; i++) {
    bottomCardsSkeleton += `
     <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
                        <div class="my-site-lazy-loading-card">
                        <div class="my-site-lazy-loading-card-movement"></div>
                    </div>
                </div>
    `;
  }

  const html = `

    <div id="placeholder-buildComponentBlogCategories">
  
     <div class="blog-breadcrumb-section-wide-wrapper">
        
             <br>
                <br>
                <br>
                <br>
                 <br>
                <br>
                <br>
                <br>
          
    </div>

    <center>

    <div class="myPageMargins">

        <div class="grid-blog-home-all-category-section">

                 ${middleCardsSkeleton}

        </div>


    </div>

    </center>


     </div> 
    
   
  `;

  return html;
}

export async function buildActualContent() {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyRecentArticles: lblRecentArticles,
    keyBlogCategoryNotFoundMessage: lblBlogCategoryNotFoundMessage,
    keyHome: lblHome,
    keyBlogHome: lblBlogHome,
    keyAllCategories: lblAllCategories,
    keyAllBlogCategories: lblAllBlogCategories,
  } = _tempTextTranslator;

  const { keyBlog: linkBlog } = _tempLinksTranslator;

  const dtAPIResultAllBlogCategories = await fetchAllBlogCategories();

  const breadCrumbHTML = await renderBreadCrumbHTML(
    linkBlog,
    lblBlogHome,
    lblAllCategories,
    lblAllBlogCategories
  );

  const remainingMiddleFeaturedAreaHTML = await renderRemainingMiddleFeaturedAreaHTML(
    dtAPIResultAllBlogCategories,
    linkBlog
  );

  const html = `
      
          <div class="blog-breadcrumb-section-wide-wrapper">

              ${breadCrumbHTML}
          
    </div>

    <center>

    <div class="myPageMargins">

         <div class="grid-blog-home-all-category-section">

               ${remainingMiddleFeaturedAreaHTML}

        </div>


    </div>

    </center>


      






        `;

  return html;
}

export async function initbuildComponentBlogCategories() {
  try {
    console.log('✅ buildComponentBlogCategory event listeners attached.');

    let htmlToRender = await buildActualContent();

    const currentPlacholder = document.querySelector('#placeholder-buildComponentBlogCategories');
    if (currentPlacholder) {
      currentPlacholder.innerHTML = htmlToRender;
    }

    updateBlogTopNavSelectedHighlightToSelectedListeners();
  } catch (error) {
    console.error('❌ Error attaching event listeners to buildComponentBlogCategory:', error);
  }
}

export async function renderBreadCrumbHTML(
  linkBlog,
  lblBlogHome,
  lblAllCategories,
  lblAllBlogCategories
) {
  const html = `


    
        <center>
            <div class="myPageMargins">
                <div class="grid-blog-category-breadcrumb-links-section">



                    <div class="breadcrumb-item"><a href="${linkBlog}">${lblBlogHome}</a></div>
                    <div class="breadcrumb-item-divider"> / </div>
                    <div class="breadcrumb-item-active">  ${lblAllCategories}   </div>



                </div>
                <h1 class="grid-blog-category-breadcrumb-section-h1"> ${lblAllBlogCategories}</h1>
            </div>
        </center>
  


       

                        `;

  return html;
}

export async function renderRemainingMiddleFeaturedAreaHTML(
  dtAPIResultAllBlogCategories,
  linkBlog
) {
  const html = dtAPIResultAllBlogCategories
    .map(item => {
      const currentNavLink = `${linkBlog}/${item.articleCategoryID}/${item.seoPageName}`;

      const container = `
                 
                    <a href="${currentNavLink}">
                        <div class="grid-blog-home-all-category-section-card">
                            <div class="grid-blog-home-all-category-section-image-wrapper">

                              <img src="${item.image1FileName}" alt="${item.name}" width="406" height="300" loading="lazy" />
                         
                            </div>



                            <div class="grid-blog-home-all-category-section-card-info-wrapper">

                                <span class="grid-blog-home-info-badge">${item.name}</span>


                                <h2 class="grid-blog-home-all-category-section-card-info-h2">
                                    ${item.name}
                                </h2>


                            </div>

                        </div>
                    </a>



       

                `;

      return container;
    })
    .join('');

  return html;
}

export async function buildComponentBlogCategoriesHeaderTags() {



  // 1. Kick off *all* dynamic imports at once, including your component
  const [{ fetchPageSEOTagsAsync }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  const currentPageSEOAPIResult = await fetchPageSEOTagsAsync('keyBlogCategories');

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo Blog Article category not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
